import DC from "@/util/SocketHandler"

export default class SocketManage {
  constructor(wsUrl, token, userType) {
    if (!userType) throw new Error("userType (ordinary/supervision) is required");
    this.wsUrl = wsUrl;
    this.token = token;
    this.userType = userType;
    this.socket = null;
    this.lockReconnect = false;
    this.lockReconnect = false;
    this.reconnectionTimes = 0;
    this.heartInterval = null;
    this.reConnectTimer = null;
    this.heartbeatLostTimes = 5;
    this.heartbeatInterval = 20;
    this.headerLength = 16;
    this.sequence = 0;
    this.registerType = 20;
    this.subscribeType = 22;
    this.heartbeatType = 32;
    // 修改点：使用箭头函数替代bind
    this.onOpen = () => {
      console.log(`${this.userType} WebSocket连接成功`);
      this.reconnectionTimes = 0;
      this.sendLogin();
      this.sendSubscribe(['RESOURCE', 'SYSTEM', 'TASK','MESSAGE']);
      this.startHeartbeat();
    };

    this.onMessage = (message) => {
      this.reconnectionTimes = 0;
      try {
        const data = JSON.parse(message.data);
        if (data.type === 'heartbeatEvt' && data.rsp === 0) return;
        data.userType = this.userType;
        DC.onmessage({ data: JSON.stringify(data) });
      } catch (e) {
        console.error('消息解析失败:', e);
      }
    };

    this.onError = () => {
      console.log(`${this.userType} Ws连接错误`);
      this.reConnect();
    };

    this.onClose = () => {
      console.log(`${this.userType} Ws连接关闭`);
      this.reConnect();
    };
    // 修改点：将方法定义为箭头函数确保this绑定
    this.clearHeartInterval = () => {
      if (this.heartInterval) {
        clearInterval(this.heartInterval);
        this.heartInterval = null;
      }
    };
    this.startHeartbeat = () => {
      this.clearHeartInterval();
      this.heartInterval = setInterval(() => {
        if (this.reconnectionTimes >= this.heartbeatLostTimes) {
          this.onClose();
          return;
        }
        this.sendHeartbeat();
        this.reconnectionTimes++;
      }, this.heartbeatInterval * 1000);
    };

    // 确保所有方法都已定义
    this.sendHeartbeat = () => {
      const heartbeatBuf = this.transBuffData(this.token, '', this.heartbeatType);
      if (this.socket && this.socket.readyState === WebSocket.OPEN) {
        this.socket.send(heartbeatBuf);
      }
    };
  }

  initWebSocket() {
    const token = this.getFreshToken();
    if (!token) {
      console.error(`[WebSocket] ${this.userType} token不存在`);
      return;
    }

    this.token = token;
    const url = (window.location.protocol === 'https:' ? 'wss://' : 'ws://') + this.wsUrl;

    try {
      this.socket = new WebSocket(url);
      this.socket.onopen = this.onOpen;
      this.socket.onmessage = this.onMessage;
      this.socket.onerror = this.onError;
      this.socket.onclose = this.onClose;
    } catch (e) {
      console.error('WebSocket初始化失败:', e);
      this.reConnect();
    }
  }

  getFreshToken() {
    return localStorage.getItem(`${this.userType}Token`) || sessionStorage.getItem(`${this.userType}Token`);
  }

  onOpen() {
    console.log(`${this.userType} WebSocket连接成功`);
    this.reconnectionTimes = 0;

    // 发送登录和订阅消息
    this.sendLogin();
    this.sendSubscribe(['RESOURCE', 'SYSTEM', 'TASK','MESSAGE']);
    this.startHeartbeat();
  }

  onMessage(message) {
    this.reconnectionTimes = 0;
    try {
      const data = JSON.parse(message.data);

      // 特殊处理心跳消息
      if (data.type === 'heartbeatEvt' && data.rsp === 0) {
        return;
      }

      // 添加用户类型信息
      data.userType = this.userType;
      DC.onmessage({ data: JSON.stringify(data) });
    } catch (e) {
      console.error('消息解析失败:', e);
    }
  }

  sendLogin() {
    const body = {
      heartbeatLostTimes: this.heartbeatLostTimes,
      heartbeatTimeout: this.heartbeatInterval
    };
    const loginBuf = this.transBuffData(this.token, JSON.stringify(body), this.registerType);
    this.socket.send(loginBuf);
  }

  sendSubscribe(modules) {
    const subBuf = this.transBuffData(this.token, JSON.stringify(modules), this.subscribeType);
    this.socket.send(subBuf);
  }

  sendHeartbeat() {
    const heartbeatBuf = this.transBuffData(this.token, '', this.heartbeatType);
    this.socket.send(heartbeatBuf);
  }

  reConnect() {
    if (this.lockReconnect) return;

    this.lockReconnect = true;
    this.clearHeartInterval();

    this.reConnectTimer = setTimeout(() => {
      console.log(`${this.userType} 尝试重新连接...`);
      this.lockReconnect = false;
      this.initWebSocket();
    }, 10000);
  }

  startHeartbeat() {
    this.clearHeartInterval();
    this.heartInterval = setInterval(() => {
      if (this.reconnectionTimes >= this.heartbeatLostTimes) {
        this.onClose();
        return;
      }
      this.sendHeartbeat();
      this.reconnectionTimes++;
    }, this.heartbeatInterval * 1000);
  }

  closeConnection() {
    this.clearHeartInterval();
    clearTimeout(this.reConnectTimer);
    if (this.socket) {
      this.socket.close();
    }
  }

  transBuffData(token, body, type) {
    this.sequence++;
    let bodyLength = 0;
    if (body !== null) {
      bodyLength = body.length;
    }

    let length = this.headerLength + token.length + bodyLength;
    let buf = Buffer.alloc(length);
    buf.writeInt32BE(length);
    buf.writeInt16BE(type, 4);
    buf.writeInt32BE(this.sequence, 6);
    buf.writeInt16BE(token.length, 12);

    let tokenBytes = this.stringToByte(token);
    for (let i = 0; i < tokenBytes.length; i++) {
      buf.writeInt8(tokenBytes[i], i + this.headerLength);
    }

    let bodyOffset = this.headerLength + token.length;
    if (body !== null) {
      let bodyBytes = this.stringToByte(body);
      for (let j = 0; j < bodyBytes.length; j++) {
        buf.writeInt8(bodyBytes[j], j + bodyOffset);
      }
    }

    return buf;
  }

  stringToByte(str) {
    let bytes = [];
    let len, c;
    len = str.length;
    for (let i = 0; i < len; i++) {
      c = str.charCodeAt(i);
      if (c >= 0x010000 && c <= 0x10ffff) {
        bytes.push(((c >> 18) & 0x07) | 0xf0);
        bytes.push(((c >> 12) & 0x3f) | 0x80);
        bytes.push(((c >> 6) & 0x3f) | 0x80);
        bytes.push((c & 0x3f) | 0x80);
      } else if (c >= 0x000800 && c <= 0x00ffff) {
        bytes.push(((c >> 12) & 0x0f) | 0xe0);
        bytes.push(((c >> 6) & 0x3f) | 0x80);
        bytes.push((c & 0x3f) | 0x80);
      } else if (c >= 0x000080 && c <= 0x0007ff) {
        bytes.push(((c >> 6) & 0x1f) | 0xc0);
        bytes.push((c & 0x3f) | 0x80);
      } else {
        bytes.push(c & 0xff);
      }
    }
    return bytes;
  }
}
